import React from "react";
import { useTranslation } from "react-i18next";

export default function ImageSuggestions({ mobileViewStep, showGeneratedImageUI, imageUrl, imageLocked }) {
  const { t } = useTranslation();

  // Hide when uploaded image or generated image is shown
  const showSuggestions = !showGeneratedImageUI && !imageUrl && imageLocked;

  // Hide on mobile steps 3 and 5
  if (mobileViewStep === 3 || mobileViewStep === 5 || !showSuggestions) return null;

  return (
    <div id="section-image-suggestions" className="mb-4 border border-black-600 rounded-lg bg-gray-50 h-auto md:h-[332px] relative">
      <div className="flex items-center justify-between p-3 bg-black-20 border-b rounded-tr-lg rounded-tl-lg">
        <div>
          <h3 className="font-bold text-lg text-black-800">{t("insights.suggestion")}</h3>
          <p className="text-sm md:text-lg text-black-600 mb-3">{t("insights.description")}</p>
          <span className="text-xl bg-Brand-lemon-100 text-black-800 px-2 py-1 rounded w-fit">{t("updates.newFeature")}</span>
        </div>
      </div>
      {[1, 2, 3].map((i) => (
        <div key={i} className="border border-gray-300 rounded-lg p-3 bg-black-0 m-1 h-[70px] relative">
          <div className="absolute inset-0 bg-black-0 rounded-lg"></div>
          <div className="absolute inset-0 p-2 flex flex-col justify-start space-y-1 overflow-hidden rounded-lg">
            <div className="flex space-x-2"><div className="h-6 u-skeleton w-full max-w-[300px]"></div></div>
            <div className="flex space-x-2"><div className="h-6 u-skeleton w-full max-w-[340px]"></div></div>
          </div>
        </div>
      ))}
    </div>
  );
}